/**
 * Shared, cross-feature constants. Things reused by more than one feature live
 * here (imported via the `@/config` barrel) so there's a single source of truth.
 */

/**
 * Date-range presets for the shared `CDateRangeFilter` (the Venues & Spaces
 * stats filter and the Calendar page header). Each `slug` is the platform
 * `?range=` enum value (1:1 with the backend); `label` is the UI copy.
 * See `docs/api-requests/answer/DONE-2026-06-16-venues-stats-date-filter-answers.md`.
 */
export const DATE_RANGE_PRESETS = [
  { label: "Today", slug: "today" },
  { label: "Yesterday", slug: "yesterday" },
  { label: "This week", slug: "this_week" },
  { label: "This Month", slug: "this_month" },
  { label: "Last 7 days", slug: "last_7_days" },
  { label: "Last 30 days", slug: "last_30_days" },
  { label: "Last 90 days", slug: "last_90_days" },
  { label: "This year", slug: "this_year" },
] as const;

/** Default range when none is supplied (matches the backend default). */
export const DEFAULT_DATE_RANGE = "this_month";

/** Dashboard stat cards default to this_month (matches API param-less default). */
export const DEFAULT_DASHBOARD_DATE_RANGE = "this_month";

/** Map a range slug to its UI label (falls back to the default preset's label). */
export function labelForDateRange(slug: string | undefined): string {
  const match = DATE_RANGE_PRESETS.find((p) => p.slug === slug);
  if (match) return match.label;
  return (
    DATE_RANGE_PRESETS.find((p) => p.slug === DEFAULT_DATE_RANGE)?.label ??
    DATE_RANGE_PRESETS[0].label
  );
}
